import { z } from 'zod';
import { documentDefaultValue, documentOptionalSchema, getDocumentSchema, getPhotoSchema, photoOptionalSchema } from '../../../constants/sharedSchemas';

export const documentsSchema = {
  required: z.object({
    passportDocument: getPhotoSchema('Passport'),
    birthCertificateDocument: getPhotoSchema('Birth certificate'),
    englishTeacherRecommendationDocument: getDocumentSchema("English teacher's recommendation"),
    allowParticipantToView: z.boolean(),
    transcriptsDocument: getPhotoSchema('Transcripts document'),
    transcriptGradesFormDocument: getDocumentSchema('Transcript grades form'),
    medicalRecordsDocument: getDocumentSchema('Medical records document'),
    recordPhysicalExaminationDocument: getDocumentSchema('Record of Physical Examination'),
    dentalCertificationDocument: getDocumentSchema('Dental Certification'),
    parentFormDocument: getDocumentSchema('Parent form'),
    eltis: z.object({
      eLTISLevel: z.string().min(1, 'ELTIS test type is required'),
      englishTestScore: z.string().min(1, 'English test score is required'),
      eLTISDocument: getDocumentSchema('English Test Documentation'),
    }),
  }),
  optional: z.object({
    passportDocument: photoOptionalSchema,
    birthCertificateDocument: photoOptionalSchema,
    englishTeacherRecommendationDocument: documentOptionalSchema,
    allowParticipantToView: z.boolean(),
    transcriptsDocument: photoOptionalSchema,
    transcriptGradesFormDocument: documentOptionalSchema,
    medicalRecordsDocument: documentOptionalSchema,
    recordPhysicalExaminationDocument: documentOptionalSchema,
    dentalCertificationDocument: documentOptionalSchema,
    parentFormDocument: documentOptionalSchema,
    eltis: z.object({
      eLTISLevel: z.string().optional(),
      englishTestScore: z.string().optional(),
      eLTISDocument: documentOptionalSchema,
    }),
  }),
};

export type DocumentsFormValues = z.infer<(typeof documentsSchema)['required']> | z.infer<(typeof documentsSchema)['optional']>;

export const defaultValues: DocumentsFormValues = {
  passportDocument: { id: '' },
  birthCertificateDocument: { id: '' },
  englishTeacherRecommendationDocument: documentDefaultValue,
  allowParticipantToView: false,
  transcriptsDocument: { id: '' },
  transcriptGradesFormDocument: documentDefaultValue,
  medicalRecordsDocument: documentDefaultValue,
  recordPhysicalExaminationDocument: documentDefaultValue,
  dentalCertificationDocument: documentDefaultValue,
  parentFormDocument: documentDefaultValue,
  eltis: {
    eLTISLevel: '',
    englishTestScore: '',
    eLTISDocument: documentDefaultValue,
  },
};
